<div class="image-header-renderer" (click)="onSortRequested($event)" [title]="imageTitle">
  <svg-icon-sprite
    *ngIf="iconSrc"
    [src]="iconSrc"
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
  ></svg-icon-sprite>
  <span class="ag-sort-ascending-icon" *ngIf="sortDirection === 'asc'">
    <span class="ag-icon ag-icon-asc" unselectable="on" role="presentation"></span>
  </span>
  <span class="ag-sort-descending-icon" *ngIf="sortDirection === 'desc'">
    <span class="ag-icon ag-icon-desc" unselectable="on" role="presentation"></span>
  </span>
</div>
